// TODO: данный функционал должен переехать в модуль или feature
// либо в пакет для работы с A/B-тестами

interface IABTests {
  id: number;
  group: "test" | "control" | "skipped";
}

export const getTestGroup = (
  tests: IABTests[],
  testNumber: number
): "test" | "control" | "skipped" | false => {
  for (let i = 0; i < tests.length; i++) {
    if (tests[i].id == testNumber) {
      return tests[i].group;
    }
  }

  return false;
};
